import { TextInput, TextInputProps } from "@mantine/core";

interface ContactInputProps extends Omit<TextInputProps, "form"> {
  form?: { setFieldValue: (key: string, value: any) => void };
  name: string;
}

export function ContactInput({ form, name, ...props }: ContactInputProps) {
  const formatPhoneNumber = (value: string) => {
    const digits = value.replace(/\D/g, "");

    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    if (digits.length === 10)
      return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
    if (digits.length >= 11)
      return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;

    return digits;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target.value;
    const formatted = formatPhoneNumber(input);

    form?.setFieldValue(name, formatted);
  };

  return <TextInput maxLength={13} {...props} name={name} onChange={handleChange} />;
}
